<template>
  <div class="app-container crm-detail business-detail">
    <el-card class="crm-detail-base" shadow="never">
      <el-row>
        <el-col :span="16">
          <span class="base-name">{{detail.orderNum}}</span>
        </el-col>
        <el-col :span="8" v-if="detail.id" align="right">
          <el-button type="text" @click="handleAssign()">分配</el-button>
          <el-button type="text" v-if="detail.orderStatus === 10"  @click="handleResolve">处理</el-button>
        </el-col>
      </el-row>
      <div class="overflowH">
        <div class="base-item">
          <div class="title label">订单状态</div>
          <div class="value">{{detail.orderStatusDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">客户</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.customer(detail.customerId, '_blank')">{{detail.customerName}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">客户性质</div>
          <div class="value">{{detail.customerNature}}</div>
        </div>
        <div class="base-item">
          <div class="title label">交付订单</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="$jump.deliver(detail.deliveryOrderId, '_blank')">{{detail.deliveryOrderNum}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">问题类型</div>
          <div class="value">{{detail.problemJudges}}</div>
        </div>
        <div class="base-item">
          <div class="title label">服务金额(元)</div>
          <div class="value" v-if="!detail.serviceFee === 0">{{amountFormat(detail.serviceFee || 0)}}元</div>
          <div class="value" v-else>免费</div>
        </div>
        <div class="base-item">
          <div class="title label">问题日期</div>
          <div class="value">{{detail.problemHappenDate}}</div>
        </div>
        <div class="base-item">
          <div class="title label">处理日期</div>
          <div class="value">{{detail.dealDate}}</div>
        </div>
      </div>
    </el-card>
    <el-row :gutter="16">
      <el-col :span="16">
        <el-card class="crm-detail-main" v-if="detail.id" shadow="never">
          <el-tabs v-model="activeName" @tab-click="handleTabClick" :stretch="true">
            <el-tab-pane label="跟进记录" name="followPlan">
                <FollowAdd ref="followAddRef"  :targetId="detail.id" targetType="serviceOrder" :businessStageCode="detail.currentStageCode"
                            @success="handleAfterFollowAdd"></FollowAdd>
                <div style="height: 473px">
                <FollowList :targetId="detail.id" targetType="serviceOrder" ref="followListRef"></FollowList>
                </div>
            </el-tab-pane>
            <el-tab-pane label="订单信息" name="detail">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="text" @click="handleEdit"  v-if="!editModel">编辑</el-button>
                  <el-button type="primary" @click="handleEditSave" v-if="editModel">保存</el-button>
                  <el-button  @click="editModel = false" v-if="editModel">取消</el-button>
                </el-col>
              </el-row>
              <el-form :model="updateData" :rules="updateRules" ref="updateForm" label-width="135px" :hide-required-asterisk="!editModel">
                <el-card shadow="never" class="el-card-simple card-item">
                  <div slot="header">
                    <span>基本信息</span>
                  </div>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="订单编号:">
                        <span class="value">{{detail.orderNum}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="订单状态:">
                        <span class="value" style="margin-right: 10px" >{{detail.orderStatusDesc}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="客户:" prop="customerId">
                        <el-select v-if="editModel" v-model="updateData.customerId" placeholder="请选择客户" clearable style="width:100%">
                          <el-option v-for="dict in customerList" :key="dict.id" :label="dict.customerName" :value="dict.id"/>
                        </el-select>
                        <el-link v-else type="primary" class="crm-link-wrap" :underline="false" @click="$jump.customer(detail.customerId, '_blank')">{{detail.customerName}}</el-link>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="交付订单:" prop="deliveryOrderId">
                        <el-select v-if="editModel" v-model="updateData.deliveryOrderId" placeholder="请选择交付订单" clearable style="width:100%">
                          <el-option v-for="dict in deliveryList" :key="dict.id" :label="dict.orderNum" :value="dict.id"/>
                        </el-select>
                        <el-link v-else type="primary" class="crm-link-wrap" :underline="false" @click="$jump.deliver(detail.deliveryOrderId, '_blank')">{{detail.deliveryOrderNum}}</el-link>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="服务类型:" prop="serviceType">
                        <el-select v-if="editModel" v-model="updateData.serviceType" placeholder="请选择服务类型" clearable style="width:100%">
                          <el-option v-for="dict in serviceTypeList" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                        <span v-else class="value">{{detail.serviceTypeDesc}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="服务方式:" prop="serviceWay">
                        <el-select v-if="editModel" v-model="updateData.serviceWay" placeholder="请选择服务方式" clearable style="width:100%">
                          <el-option v-for="dict in seviceWayOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                        <span v-else class="value" style="margin-right: 10px" >{{detail.serviceWayDesc}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="问题判定:" prop="problemJudgeList">
                        <el-select v-if="editModel" v-model="updateData.problemJudgeList" placeholder="请选择问题判定" clearable style="width:100%" multiple>
                          <el-option v-for="dict in problemJudgeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                        <span v-else class="value">{{detail.problemJudges}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="问题概述:" prop="problemDesc">
                        <el-input v-if="editModel" v-model="updateData.problemDesc" :maxlength="500" placeholder="请输入问题概述" clearable/>
                        <span v-else class="value" style="margin-right: 10px" >{{detail.problemDesc}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="问题图片:" prop="businessName">
                        <FileUpload v-if="editModel" v-model="updateData.problemPicList" accept="image/gif,image/jpg,image/jpeg,image/png" :limit="9" :readOnly="false" @on-change="handleFileChange"></FileUpload>
                        <FileUpload v-else v-model="detail.problemPicList" :readOnly="true"></FileUpload>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="问题发生日期:" prop="problemHappenDate">
                        <el-date-picker v-if="editModel" v-model="updateData.problemHappenDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
                        <span v-else>{{detail.problemHappenDate}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="处理方式:" prop="dealWay">
                        <el-input v-if="editModel" v-model="updateData.dealWay" :maxlength="32" placeholder="请输入处理方式" clearable/>
                        <span v-else class="value" style="margin-right: 10px" >{{detail.dealWay}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="经验总结:" prop="experienceSummary">
                        <el-input v-if="editModel" v-model="updateData.experienceSummary" :maxlength="32" placeholder="请输入经验总结" clearable/>
                        <span v-else class="value">{{detail.experienceSummary}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="服务费用(元):" prop="serviceFee">
                        <el-input v-if="editModel" v-model="updateData.serviceFee" type="number" :maxlength="32" placeholder="请输入服务费用" clearable/>
                        <span v-else class="value" style="margin-right: 10px" >
                          <template v-if="detail.serviceFee !== 0">{{amountFormat(detail.serviceFee || 0)}}元</template>
                          <template v-else>免费</template>
                        </span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                   <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="创建人:" prop="businessSource">
                        <span class="value" style="margin-right: 10px" >{{detail.createUserName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="创建时间:" prop="businessScale">
                        <span class="value" style="margin-right: 10px" >{{detail.createTime}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <el-card shadow="never" class="el-card-simple card-item">
                  <div slot="header">
                    <span>项目信息</span>
                  </div>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="项目区域:" prop="customerId">
                        <el-cascader v-if="editModel" v-model="updateData.area" :options="areaOptions" :props="{ checkStrictly: true }" filterable clearable style="width:100%"></el-cascader>
                        <span v-else class="value" @click="skipCustomerDetail(detail.customerId)">{{detail.areaName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="项目地址:" prop="requirements">
                        <el-input v-if="editModel" v-model="updateData.address" :maxlength="64" placeholder="请输入详细地址" clearable/>
                        <span v-else class="value">{{detail.address}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="污水类型:" prop="requirements">
                        <el-select v-if="editModel" v-model="updateData.sewageType" placeholder="请选择污水类型" clearable style="width:100%">
                          <el-option v-for="dict in sewageTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                        <span v-else class="value">{{detail.sewageType}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="日处理量:" prop="requirements">
                        <el-input v-if="editModel" v-model="updateData.dailyProcessCapacity" :maxlength="100" placeholder="请输入日处理量" clearable/>
                        <span v-else class="value">{{detail.dailyProcessCapacity}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <el-card shadow="never" class="el-card-simple card-item">
                  <div slot="header">
                    <span>处理信息</span>
                  </div>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="处理日期:" prop="dealDate">
                        <el-date-picker v-if="editModel" v-model="updateData.dealDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
                        <span v-else class="value">{{detail.dealDate}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="24">
                      <el-form-item label="备注:" prop="dealRemark">
                        <el-input
                          v-if="editModel"
                          type="textarea"
                          :autosize="{ minRows: 3, maxRows: 5}"
                          :maxlength="1000"
                          show-word-limit
                          v-model="updateData.dealRemark"
                          placeholder="请输入"
                          clearable/>
                        <span v-else class="value">{{detail.dealRemark}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="售后产品" name="contact">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button  @click="handleAddSaleProduct" type="primary">添加</el-button>
                </el-col>
              </el-row>
              <SaleProduct class="card-item" :dataObj="detail.afterSaleProductList" @success="refreshDetailAndLog"/>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="crm-detail-follow" v-if="detail.id" shadow="never">
          <div class="label">负责人</div>
          <div class="crm-manager">
            <UserAvatar class="avatar" :url="detail.managerAvatar" :name="detail.managerName"/>
            <div class="name"><span class="value">{{detail.managerName}}</span></div>
          </div>
          <GroupMember :groupName="'团队'" :targetId="detail.id" :targetType="'serviceOrder'"
                       :canAddGroupMemberFlag="detail.canAddGroupMemberFlag" @success="handleGroupMemberSuccess"/>
          <el-divider content-position="left"><span class="label">操作日志</span></el-divider>
          <div style="height: 534px">
            <OperateLogList ref="operateLogListRef" :targetId="detail.id" targetType="serviceOrder"></OperateLogList>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <AssignDialog ref="assignDialogRef" @success="refreshDetailAndLog"></AssignDialog>

    <!-- 处理服务单 -->
    <ResolveServiceDialog ref="resolveServiceDialogRef" @success="refreshDetailAndLog"></ResolveServiceDialog>
    <!-- 添加售后产品 -->
    <SaleProductDialog ref="saleProductDialogRef" @success="refreshDetailAndLog"></SaleProductDialog>
  </div>
</template>

<script>
import {
  listSimpleAll
} from "@/api/crm/customer";
import { queryServiceDetail, listDeliveryByPage, editService } from "@/api/crm/order"
import FileUpload from "@/views/crm/components/fileUpload";
import ResolveServiceDialog from "./resolveServiceDialog";
import SaleProduct from "./saleProduct"
import SaleProductDialog from "./saleProductDialog"
import FollowList from "@/views/crm/follow/followList";
import FollowAdd from "@/views/crm/follow/followAdd";
import OperateLogList from "@/views/crm/components/operateLogList";
import AssignDialog from "@/views/crm/components/assignDialog";
import UserAvatar from '@/views/system/user/userAvatar'
import { amountFormat, transferCascaderOptionsForProvince } from '@/utils/index'
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {mapState} from 'vuex'
import {listAllLevelArea} from '@/api/crm/area'
import GroupMember from "@/views/crm/groupMember"

export default {
  name: "BusinessDetail",
  data() {
    return {
      amountFormat,
      // 遮罩层
      loading: true,
      detail: {},
      swot: {},
      activeName: "followPlan",
      followPlanActiveName: 'follow',
      editModel: false,
      editSwotModel: false,
      contactCount: 0,
      contractCount: 0,
      customerList: [], //客户
      deliveryList: [], //交付订单
      areaOptions: [],
      seviceWayOptions: [],
      sewageTypeOptions: [],
      problemJudgeOptions: [], // 问题判定
      serviceTypeList: [{ // 服务类型
        dictLabel: '主动',
        dictValue: 1
      },{
        dictLabel: '被动',
        dictValue: 2
      }],
      updateData: {
        id: null,
        customerId: null,
        deliveryOrderId: null,
        serviceType: null,
        serviceWay: null,
        problemJudgeList: [],
        problemDesc: null,
        problemHappenDate: null,
        dealWay: null,
        experienceSummary: null,
        area: [],
        address: null,
        sewageTypeList: [],
        dailyProcessCapacity: null
      },

      updateRules: {
        customerId: [
          { required: true, message: "请选择客户", trigger: "change" }
        ],
        serviceType: [
          { required: true, message: "请选择服务类型", trigger: "change" }
        ],
        serviceWay: [
          { required: true, message: "请选择服务方式", trigger: "change" }
        ],
        problemJudgeList: [
          { required: true, message: "请选择问题判定", trigger: "change" }
        ],
        problemDesc: [
          { required: true, message: "请输入问题概况", trigger: "change" }
        ],
        problemHappenDate: [
          { required: true, message: "请选择日期", trigger: "change" }
        ],
        serviceFee: [
          { required: true, message: "请输入服务费用", trigger: "change" }
        ],
        area: [
          { required: true, message: "请选择项目区域", trigger: "change" }
        ],
        address: [
          { required: true, message: "请输入项目地址", trigger: "change" }
        ],
        sewageType: [
          { required: true, message: "请选择污水类型", trigger: "change" }
        ],
        dailyProcessCapacity: [
          { required: true, message: "请输入日处理量", trigger: "change" }
        ]
      },
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
    })
  },
  components: {
    FollowList,
    FollowAdd,
    OperateLogList,
    AssignDialog,
    UserAvatar,
    ResolveServiceDialog,
    SaleProduct,
    FileUpload,
    SaleProductDialog,
    GroupMember
  },
  created() {
    if (this.$route.params.id) {
      this.queryDetail()
    } else {
      this.msgError("无效的商机");
    }
    this.getDicts("service_order_service_way").then(response => {
      this.seviceWayOptions = response.data;
    });
    this.getDicts("problem_judge").then(response => {
      this.problemJudgeOptions = response.data;
    });
    this.getDicts("sewage_type").then(response => {
      this.sewageTypeOptions = response.data;
    });
    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
    listSimpleAll().then(response => {
      this.customerList = response.data;
    });
  },
  watch: {
    editModel (val) {
      if (!val) {
        this.resetForm("updateForm");
      }
    }
  },
  methods: {
    handleTabClick (tab) {
      if (tab.name === 'contact') {
      } else if (tab.name === 'contract') {
      }else if (tab.name === 'plan') {
      }
    },
    refreshDetailAndLog() {
      this.$refs["followAddRef"].queryAtList()
      this.queryDetail()
      this.refreshOperateLogList();
    },
    queryDetail () {
      queryServiceDetail({id:this.$route.params.id}).then(response => {
        if (response.data) {
          this.detail = response.data
          listDeliveryByPage({ customerId: this.detail.customerId }).then(response => {
            this.deliveryList = response.rows || [];
          });
        } else {
          this.msgError("查询不到此服务单");
        }
      }).catch(error => {
        this.detail = {}
      })
    },
    customerChange(customerId) {
      this.deliveryList = [];
      this.data.deliveryOrderId = null;
      if (customerId) {
        listDeliveryByPage({ customerId: customerId }).then(response => {
          this.deliveryList = response.rows || [];
        });
      }
    },
    handleAfterFollowAdd () {
      this.$refs.followListRef.refresh()
      this.queryDetail()
    },
    refreshOperateLogList () {
      this.$refs.operateLogListRef.refresh()
    },
    skipCustomerDetail(id) {
      this.$router.push("/crm/customer/detail/" + id);
    },
    // 编辑订单信息
    handleEdit() {
      this.updateData = JSON.parse(JSON.stringify(this.detail))
      this.updateData.serviceWay = this.detail.serviceWay.toString()
      this.updateData.area = []
      if(this.detail.provinceCode){
        this.updateData.area.push(this.detail.provinceCode)
      }
      if(this.detail.cityCode){
        this.updateData.area.push(this.detail.cityCode)
      }
      if(this.detail.regionCode){
        this.updateData.area.push(this.detail.regionCode)
      }
      this.editModel = true
    },
    handleEditSave () {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          this.updateData.provinceCode = this.updateData.area && this.updateData.area.length > 0 ? this.updateData.area[0] : null
          this.updateData.cityCode = this.updateData.area && this.updateData.area.length > 1 ? this.updateData.area[1] : null
          this.updateData.regionCode = this.updateData.area && this.updateData.area.length > 2 ? this.updateData.area[2] : null
          editService(this.updateData).then(response => {
            this.refreshDetailAndLog();
            this.editModel = false
            loading.close();
            this.msgSuccess("更新成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.singleAssign("serviceOrder", this.detail.id)
    },
    /** 处理操作 */
    handleResolve(row) {
      this.$refs.resolveServiceDialogRef.open(this.detail.id, this.detail.dealDate, this.detail.dealRemark);
    },
    /** 新增售后产品操作 */
    handleAddSaleProduct() {
      this.$refs.saleProductDialogRef.open(this.detail.id, {});
    },
    handleFileChange (fileObjs) {
      this.updateData.problemPicList = fileObjs;
    },
    handleGroupMemberSuccess(userId) {
      if (this.currentUserId === userId) {
        this.queryDetail()
      }
      this.refreshOperateLogList()
      if (this.$refs.followAddRef) {
        this.$refs.followAddRef.queryAtList()
      }
    },
  }
};
</script>
<style lang='scss' scoped>
.card-item {
  border-radius: 6px;
  padding: 20px;
  border: 1px solid #d9d9d9;
  margin-bottom: 20px;
}
.title{
  text-align: center;
}
  .business-detail {
    .closeFlagInfo {
      cursor: default;
      color: black;
    }
    .group-member-add-btn {
      width: 40px;
      height: 40px;
      text-align: center;
      border-radius: 50%;
      padding: 0 0 0 2px;
      position: absolute;
      top: -12px;
    }

    .group-member {
      width: 120px;
      margin-bottom: 20px;
      height: 40px;

      .avatar {
        float: left;
      }

      .name {
        margin-left: 45px;
        line-height: 50px;
        margin-top: -12px;
      }

      .value {
        width: 75px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }

      .group-member-remove-btn {
        margin-left: -5px;
        cursor: pointer;
        position: absolute;
      }
    }
  }
</style>
